import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const userActions = {
    login,
    logout,
    register,
    getAll,
    delete: _delete,
    forgotPassword,
    changePassword
};
function changePassword(oldpassword,newpassword){
    return dispatch => {
        dispatch(request({oldpassword,newpassword}));      
        
        userService.changePassword(oldpassword,newpassword)
            .then(
                user => { 
                    dispatch(success(user));    
                    dispatch(alertActions.success('Se cammbiado correctaente su contraseña'));                 
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function request(user) { return { type: userConstants.CHANGE_PASSWORD_REQUEST, user } }
    function success(user) { return { type: userConstants.CHANGE_PASSWORD_SUCCESS, user } }
    function failure(error) { return { type: userConstants.CHANGE_PASSWORD_FAILURE, error } }

}
function forgotPassword(email) {    
    return dispatch => {
        dispatch(request({ email }));       
        
        userService.forgotPassword(email)
            .then(
                user => { 
                    dispatch(success(user));
                                   
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error('El email no se encuentra registrado'));
                }
            );
    };

    function request(user) { return { type: userConstants.FORGOT_REQUEST, user } }
    function success(user) { return { type: userConstants.FORGOT_SUCCESS, user } }
    function failure(error) { return { type: userConstants.FORGOT_FAILURE, error } }
}

function login(username, password) {    
    return dispatch => {
        dispatch(request({ username }));        
      
       userService.login(username, password)
            .then(
                user => { 
                    dispatch(success(user));
                    history.push('/');
                    
                 
                },
               error => {
                   let err;
                   console.log(error.message)
                if (error.message == "Request failed with status code 404")
                { 
                    err='Usuario o Contraseña incorrectas';
                }               
                else { 
                    err='Hubo un error en la conexion del servidor'; 
              }             
                dispatch(failure(err));
                dispatch(alertActions.error(err));           
                   
                }
            )                    
        };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function register(user) {
    return dispatch => {
        dispatch(request(user));        
        return userService.register(user)
            .then(
                user => {                    
                    if(user.data.success){
                        dispatch(success());
                        history.push('/login');
                        dispatch(alertActions.success('Se ha registrado Satisfactoria, Se ha enviado un Email con la contraseña'));
                    }
                   else{                    
                    dispatch(alertActions.error("La dirección de correo electrónico ya esta en uso"));
                   }
                },
                error => {
                    dispatch(failure('Hubo un error en la conexion del servidor'));
                    dispatch(alertActions.error('Hubo un error en la conexion del servidor'));
                }
            )      
              };
    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function getAll() {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => dispatch(success(id)),
                error => dispatch(failure(id, error.toString()))
            );
    };

    function request(id) { return { type: userConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: userConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: userConstants.DELETE_FAILURE, id, error } }
}